import { Collapse, Paper, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { GetHours, ToFormData } from "../../hooks/Method";
import { useContext, useEffect, useState } from "react";
import StoreMetrics from "./StoreMetrics";
import { action, API, controller } from "../../api/api";
import { AppContext } from "App";

const OutletProg = ({ sortDate }) => {
  const { settings } = useContext(AppContext);
  const [showMetrics] = useState(false);
  const [values, setValues] = useState({});
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sortDate.fromDate && sortDate.toDate) {
      setLoading(true);
      API(controller.HomeReport + action.OutletSalesReport).post(
        ToFormData({
          fromDate: new Date(sortDate.fromDate).toISOString(),
          toDate: new Date(sortDate.toDate).toISOString(),
        }),
        (res) => {
          res && res.status === 200 && setValues({ ...res.result });
          setLoading(false);
        }
      );
    }
    return () => {};
  }, [sortDate]);

  useEffect(() => {
    if (values && values.outlets && values.outlets.length > 0) {
      setSeries([
        ...values.outlets.map((j) => ({
          name: j.outletName,
          data: j.salesData,
        })),
      ]);
    } else setSeries([]);
    return () => {};
  }, [values]);

  const options = {
    chart: {
      height: 350,
      type: "area",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: GetHours(),
    },
    yaxis: {
      labels: {
        formatter: (val) => `${settings?.currSymbol} ` + val,
        style: {
          fontSize: "14px",
        },
      },
    },
  };

  return !loading ? (
    <>
      <Paper className="shadow-xs p-[15px] bg-white">
        {/* Chart */}
        <Typography
          varint="h6"
          className="text-[18px] !font-medium text-slate-500 mb-[10px]"
        >
          All Outlet Sales
        </Typography>

        <ReactApexChart
          options={options}
          series={series}
          type="area"
          width="100%"
          height="300"
        />
        {/* <div className="text-right">
          <Button
            variant="text"
            onClick={handleShowMetrics}
            endIcon={<KeyboardArrowDownRounded />}
          >
            Show more retail metrics
          </Button>
        </div> */}
      </Paper>

      <Collapse in={showMetrics}>
        <StoreMetrics />
      </Collapse>
    </>
  ) : (
    "Loading..."
  );
};

export default OutletProg;
